<template>
    <div class="user-config">
        <!-- 隐私设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-lock"></i>
                隐私设置
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-user-solid"></i>
                    <span>加我为好友时需要验证</span>
                </div>
                <div class="setting-content">
                    <el-switch v-model="userInfo.isManualApprove" @change="onManualApproveChange"></el-switch>
                </div>
            </div>
        </div>

        <!-- 通知设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-bell"></i>
                通知设置
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-microphone"></i>
                    <span>新消息提示音</span>
                </div>
                <div class="setting-content">
                    <el-switch v-model="userInfo.isAudioTip" @change="onMessageAudioTip"></el-switch>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "userConfig",
    data() {
        return {
            userInfo: {
                isManualApprove: false,
                isAudioTip: false
            }
        }
    },
    methods: {
        init() {
            let mine = this.userStore.userInfo;
            this.userInfo = JSON.parse(JSON.stringify(mine));
        },
        onManualApproveChange() {
            this.$http({
                url: "/user/manualApprove?enabled=" + this.userInfo.isManualApprove,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        },
        onMessageAudioTip() {
            this.$http({
                url: "/user/audioTip?enabled=" + this.userInfo.isAudioTip,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        }
    }
}
</script>
<style scoped lang="scss">
.user-config {
    padding: 18px 20px 24px;
    background: transparent;
    min-height: 400px;

    // 表单区域 (glass-l1)
    .form-section {
        background: rgba(255, 252, 243, 0.62);
        backdrop-filter: blur(24px) saturate(140%);
        -webkit-backdrop-filter: blur(24px) saturate(140%);
        border: 0.5px solid var(--glass-border);
        border-radius: var(--radius-md);
        padding: 16px 18px;
        margin-bottom: 14px;
        box-shadow:
            inset 0 1px 0 0 var(--glass-border-inner),
            0 1px 2px rgba(31, 31, 35, 0.04),
            0 8px 24px rgba(31, 31, 35, 0.06);

        .section-title {
            margin: 0 0 14px 0;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: -0.3px;
            color: var(--im-text-color);
            display: flex;
            align-items: center;
            gap: 8px;
            padding-bottom: 10px;
            border-bottom: 0.5px solid var(--hairline-soft);

            i {
                color: var(--aurora-blue);
                font-size: 16px;
                background: linear-gradient(135deg, rgba(91, 141, 238, 0.14), rgba(168, 139, 255, 0.10));
                width: 26px; height: 26px;
                border-radius: 8px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    // 设置项
    .setting-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 0.5px solid var(--hairline-soft);

        &:last-child { border-bottom: none; }

        .setting-label {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 10px;
            font-weight: 500;
            color: var(--im-text-color);
            font-size: var(--im-font-size);

            i {
                color: var(--aurora-blue);
                font-size: 16px;
            }
        }

        .setting-content {
            flex: 1;
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>
